<template>
  <v-dialog
    v-model="display"
    max-width="580"
    content-class="rounded-xl elevation-0"
    @keydown.enter="display = false"
    :persistent="persistent"
    :fullscreen="fullscreen"
    :transition="
      fullscreen ? 'scroll-y-reverse-transition' : 'scale-transition'
    "
  >
    <v-card elevation="0" rounded="lg" class="app-sunset-download-modal-card">
      <div class="app-sunset-download-modal-content">
        <div class="app-sunset-download-modal-close-container">
          <v-icon color="#828282" size="24" @click="display = false">
            mdi-close
          </v-icon>
        </div>
        <div class="app-sunset-download-modal-container">
          <div class="app-sunset-download-modal-logos-container">
            <v-img
              :src="require('@/assets/migration/mi-dva-logo-android.png')"
              contain
            />
            <div class="app-sunset-download-modal-logos-arrow">
              <v-icon color="#232323" :size="$vuetify.breakpoint.xs ? 20 : 24">
                mdi-arrow-right-thin
              </v-icon>
            </div>
            <v-img
              :src="require('@/assets/migration/nauta-logo-android.png')"
              contain
            />
          </div>

          <h3 class="app-sunset-download-modal-title">
            {{
              $vuetify.breakpoint.xs
                ? "Descarga la app Nauta"
                : "Escanea el código para descargar la app Nauta"
            }}
          </h3>

          <div
            v-if="!$vuetify.breakpoint.xs"
            class="app-sunset-download-modal-qr-container"
          >
            <v-img
              contain
              :src="require('@/assets/migration/nauta-download-qr.png')"
            />
          </div>

          <div v-if="!$vuetify.breakpoint.xs" class="app-sunset-download-modal-download-here">
            O descárgala aquí:
          </div>

          <div class="app-sunset-download-modal-button-row">
            <div class="app-sunset-download-modal-button">
              <NewButton
                text="App Store"
                icon="mdi-apple"
                link="https://apps.apple.com/cl/app/nauta/id6744368351"
                iconSize="24"
              />
            </div>
            <div class="app-sunset-download-modal-button">
              <NewButton
                text="Google Play"
                link="https://play.google.com/store/apps/details?id=com.dvacapital.nauta&pcampaignid=web_share"
                icon="mdi-google-play"
                iconSize="24"
              />
            </div>
          </div>

          <div class="app-sunset-download-modal-web-link-container">
            <a
              class="app-sunset-download-modal-web-link"
              href="https://app.nauta.pro/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prefiero la version web
            </a>
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import NewButton from "@/components/shared/NewButton.vue";

export default {
  name: "AppSunsetDownloadModal",

  components: { NewButton },

  props: {
    value: Boolean,
    fullscreen: Boolean,
    persistent: Boolean,
  },

  computed: {
    display: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("display", value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.app-sunset-download-modal-card {
  border: 1px solid #e2e0e0;
  border-radius: 40px !important;
  background: #f2f2f2;
}

.app-sunset-download-modal-content {
  height: 100%;
  padding: 24px;
}

.app-sunset-download-modal-close-container {
  display: flex;
  justify-content: flex-end;
}

.app-sunset-download-modal-container {
  padding: 24px;

  @media (max-width: 600px) {
    padding: 0;
  }
}

.app-sunset-download-modal-logos-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 8px;
}

.app-sunset-download-modal-logos-container > * {
  width: 56px;
  height: 56px;
  max-width: 56px !important;

  @media (max-width: 600px) {
    width: 44.211px;
    height: 44.211px;
    max-width: 44.211px !important;
  }
}

.app-sunset-download-modal-logos-arrow {
  background-color: #ede8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
}

.app-sunset-download-modal-title {
  margin: 24px 0;
  color: #333333;
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  line-height: 130%;
  letter-spacing: -0.64px;

  @media (max-width: 600px) {
    font-size: 24px;
    letter-spacing: -0.48px;
  }
}

.app-sunset-download-modal-qr-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-sunset-download-modal-qr-container > * {
  width: 220px;
  height: 220px;
}

.app-sunset-download-modal-download-here {
  margin: 16px 0;
  color: #646363;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 160%;
}

.app-sunset-download-modal-button-row {
  display: flex;
  gap: 8px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
}

.app-sunset-download-modal-button {
  width: 100%;
}

.app-sunset-download-modal-button ::v-deep .new-btn {
  height: 60px !important;
}

.app-sunset-download-modal-web-link-container {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

.app-sunset-download-modal-web-link {
  color: #6d48ff;
  font-size: 18px;
  font-weight: 600;
  line-height: 160%;
  text-decoration: none;

  @media (max-width: 600px) {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
